import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './css/Announcements.css';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function Announcements() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [announcements, setAnnouncements] = useState([]);
    const [selected, setSelected] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchList = useCallback(async () => {
        try {
            const res = await fetch(`${API_URL}/api/v1/announcements`);
            const data = await res.json();
            if (data.success) setAnnouncements(data.announcements);
        } catch (e) { console.error(e); }
        setLoading(false);
    }, []);

    useEffect(() => { fetchList(); }, [fetchList]);

    const fetchDetail = async (id) => {
        try {
            const res = await fetch(`${API_URL}/api/v1/announcements/${id}`);
            const data = await res.json();
            if (data.success) setSelected(data.announcement);
        } catch (e) { console.error(e); }
    };

    if (selected) {
        return (
            <div className="announcements-container">
                <button className="ann-back-btn" onClick={() => setSelected(null)}>
                    {'\u2190'} {t('announcement.backToList')}
                </button>
                <article className="ann-detail">
                    <h2>{selected.title}</h2>
                    <div className="ann-detail-meta">
                        <span className={`ann-type-badge ann-type-${selected.display_type}`}>
                            {t(`announcement.type.${selected.display_type}`)}
                        </span>
                        <span>{new Date(selected.created_at).toLocaleDateString()}</span>
                    </div>
                    {selected.popup_image_url && (
                        <div className="ann-detail-image">
                            <img src={`${API_URL}${selected.popup_image_url}`} alt={selected.title} />
                        </div>
                    )}
                    {selected.popup_text && (
                        <div className="ann-detail-popup-text">{selected.popup_text}</div>
                    )}
                    {selected.content && (
                        <div className="ann-detail-content">
                            {selected.content.split('\n').map((line, i) => (
                                <p key={i}>{line || '\u00A0'}</p>
                            ))}
                        </div>
                    )}
                </article>
            </div>
        );
    }

    return (
        <div className="announcements-container">
            <h2>{t('announcement.title')}</h2>
            {loading ? (
                <p className="ann-empty">{t('loading')}</p>
            ) : announcements.length === 0 ? (
                <p className="ann-empty">{t('announcement.noAnnouncements')}</p>
            ) : (
                <div className="ann-list">
                    {announcements.map(ann => (
                        <div
                            key={ann.announcement_id}
                            className={`ann-list-item ${ann.is_pinned ? 'ann-pinned' : ''}`}
                            onClick={() => fetchDetail(ann.announcement_id)}
                        >
                            <div className="ann-list-item-left">
                                {ann.is_pinned && <span className="ann-pin-badge">{'\uD83D\uDCCC'}</span>}
                                <span className={`ann-type-badge ann-type-${ann.display_type}`}>
                                    {t(`announcement.type.${ann.display_type}`)}
                                </span>
                                <span className="ann-list-title">{ann.title}</span>
                            </div>
                            <span className="ann-list-date">
                                {new Date(ann.created_at).toLocaleDateString()}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default Announcements;
